import request from '@/router/axios';


/**
 * 获取注册邀请信息
 * @param id
 */
export function getInvitation(id) {
  return request({
    url: `/user/invitation/${id}`,
    method: 'get',
    headers: {
      Authorization: 'Basic Y2lpYy1jbG91ZC1wbGF0Zm9ybTpjaWljLWNsb3VkLXBsYXRmb3Jt',
    },
  });
}

/**
 * 邀请的注册
 * @param id
 */
export function registerByInvitation(obj) {
  return request({
    url: '/user/invitation/user/register',
    method: 'post',
    data: obj,
    headers: {
      Authorization: 'Basic Y2lpYy1jbG91ZC1wbGF0Zm9ybTpjaWljLWNsb3VkLXBsYXRmb3Jt',
    },
  });
}
